var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.000549316,
    y: 0.000976562,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#6F767E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.51797 5.03809C6.31342 5.03809 6.1476 5.20391 6.1476 5.40846V10.5936C6.1476 10.7982 6.31342 10.964 6.51797 10.964C6.72252 10.964 6.88834 10.7982 6.88834 10.5936V5.40846C6.88834 5.20391 6.72252 5.03809 6.51797 5.03809Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.48086 5.03809C9.27631 5.03809 9.11049 5.20391 9.11049 5.40846V10.5936C9.11049 10.7982 9.27631 10.964 9.48086 10.964C9.68541 10.964 9.85123 10.7982 9.85123 10.5936V5.40846C9.85123 5.20391 9.68541 5.03809 9.48086 5.03809Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/Pause.7cb215e6d495ca4cd5a32628705c0c7e.svg";
export { ForwardRef as ReactComponent };